import { ConfigProvider } from '../context/configContext';
import { Outlet } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import '../index.css';
import { DataProvider } from '../context/dataContext';

const Home = () => {

    return (
        <div className='app w-100 h100'>
            <AnimatePresence>
                <ConfigProvider>
                    <DataProvider >
                        <Outlet />
                    </DataProvider>
                </ConfigProvider>
            </AnimatePresence>
        </div >
    )
}

export default Home;